import {useEffect} from "react";
import {useAllStore} from "@/Stores/useAllStore";

export default function useGlobalUserActivity() {
    const handleUserInteraction = useAllStore((state) => state.handleUserInteraction);

    useEffect(() => {
        setTimeout(() => {
            handleUserInteraction();
        }, 1000);

        const events = [
            'click', 'keypress', 'mousemove', 'mousedown', 'mouseup', 'dblclick', 'contextmenu', 'wheel', 'touchstart',
            'touchend', 'touchmove', 'keydown', 'keyup', 'scroll', 'resize', 'mouseenter', 'mouseleave',
        ];

        events.forEach(event =>
            document.addEventListener(event, handleUserInteraction)
        );

        return () => {
            events.forEach(event =>
                document.removeEventListener(event, handleUserInteraction)
            );
        };
    }, []);
}
